var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.374,
    height: 14.374,
    viewBox: "0 0 14.374 14.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(-780.833 -319.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(780.833 319.917)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.755,
    cy: 5.755,
    r: 5.755,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.755,
    cy: 5.755,
    r: 4.755,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 4.316,
    y2: 4.316,
    transform: "translate(790.184 329.268)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9ab2a013e5ccadf6bf4dd5153a328436.svg";
export { ForwardRef as ReactComponent };